<template>
    <div>
        <hosting-meta :domain="domain" :subscription="subscription" />

        <cancel-subscriptions :subscription="subscription" :domain="domain" />

        <hosting-statistics :domain="domain" :subscription="subscription" class="page-block__item-wrapper-settings" />

        <hosting-settings v-if="isTechnicallyActive" :domain="domain" :subscription="subscription" />

        <hosting-info
            v-if="isTechnicallyActive"
            :domain="domain"
            :subscription="subscription"
            class="page-block__item-wrapper-settings"
        />
    </div>
</template>

<script>
import { HostingMeta, HostingStatistics, HostingSettings, HostingInfo } from 'relapp-hosting';
import { CancelSubscriptions } from 'relapp-technical-management';

export default {
    components: {
        HostingMeta,
        HostingStatistics,
        HostingSettings,
        HostingInfo,
        CancelSubscriptions
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    computed: {
        /**
         * Checks if the hosting subscription is technically active.
         *
         * @return {boolean}
         */
        isTechnicallyActive() {
            return this.subscription.technical_status === 'ok';
        }
    }
};
</script>
